<template>
    <div class="box">
      <TopTabs :list="this.$nav2"></TopTabs>
      <p class="content" v-html="home.content"></p>
    </div>
</template>

<script>
import TopTabs from '@/components/topTabs_h5/index'
export default {
  name: 'xxgk',
  components: { TopTabs },
  props: {
    home: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      isMaxScreen: true

    }
  },
  computed: {},

  mounted () {
    this.isMaxScreen = document.body.clientWidth > 850
    window.addEventListener('resize', () => {
      this.isMaxScreen = document.body.clientWidth > 850
    })
  },
  created () {
  }
}
</script>

<style scoped lang="scss">
 .box {
    width: 100%;
    min-height: 200vw;

    .content{
        padding: 0 4.2667vw;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      ::v-deep p {
        font-size: 3.7333vw!important;
        line-height: 2;
        // text-align: left!important;
      }
      ::v-deep img {
        display: block;
        max-width: 100%!important;
        margin: 0 auto;
      }
    }
  }

</style>
